// extracted by mini-css-extract-plugin
export default {"stopButton":"RecordButton_stopButton__Zn6n4","pulse":"RecordButton_pulse__Q9Cps","recordButton":"RecordButton_recordButton__+-i-j"};